import { render, staticRenderFns } from "./EditCoupon.vue?vue&type=template&id=c0274766"
import script from "./EditCoupon.vue?vue&type=script&lang=ts"
export * from "./EditCoupon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports